@if (version$$(); as version) {
  <div class="w-full text-center text-xs p-1" [ngClass]="whiteText ? 'text-white' : 'text-neutral-30-secondary'">{{ version.version }} [{{ version.git?.commitId?.substring(0,7) }}]</div>
}
